/* Arflonia Produktseite v1 · Varianten · Spar-Stufen · Grundpreis · Warenkorb · Galerie · Empfehlungen */
(function () {
  'use strict';
  var D = document, W = window, H = D.documentElement;

  /* ---------- Hilfsfunktionen ---------- */
  var nf = null;
  function money(c, cur) {
    try { nf = nf || new Intl.NumberFormat('de-DE', { style: 'currency', currency: cur || 'EUR' }); return nf.format(Math.round(c) / 100); }
    catch (e) { return (Math.round(c) / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function $(s, r) { return (r || D).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  var idle = W.requestIdleCallback || function (f) { return setTimeout(f, 250); };

  /* Grundpreis (PAngV): Menge aus Text lesen, z. B. „15 kg“, „6 x 370 g“, „370g 6er Pack“, „20x15g“, „1,5 l“ */
  function parseAmount(txt) {
    var s = String(txt || '').toLowerCase().replace(/(\d),(\d)/g, '$1.$2');
    var m = s.match(/(\d+)\s*[x×]\s*(\d+(?:\.\d+)?)\s*(kg|g|ml|l)(?![a-z])/);
    var n = 1, v, u;
    if (m) { n = +m[1]; v = +m[2]; u = m[3]; }
    else {
      m = s.match(/(\d+(?:\.\d+)?)\s*(kg|g|ml|l)(?![a-z])/);
      if (!m) return null;
      v = +m[1]; u = m[2];
      var k = s.match(/(\d+)\s*-?\s*er[\s-]*(?:pack|pac|packung|set|karton|kiste)/);
      if (k && +k[1] > 1 && +k[1] <= 96) n = +k[1];
    }
    var base = u === 'kg' || u === 'l' ? v : v / 1000;
    var tot = base * n;
    if (!(tot > 0) || tot < 0.01) return null;
    return { q: tot, u: (u === 'kg' || u === 'g') ? 'kg' : 'l' };
  }
  function unitInfo(variant, productTitle, cons) {
    if (variant.up && variant.ur) return { cents: variant.up, ref: variant.ur.replace(/^1\s+/, '').replace(/^(\d+)\s*/, '$1 ') };
    if (!cons) return null;
    var vt = /^default title$/i.test(variant.t || '') ? '' : (variant.t || '');
    var a = parseAmount(vt + ' ' + (productTitle || ''));
    if (!a) return null;
    return { per: a.q, ref: a.u };
  }
  function unitText(info, priceCents, cur) {
    if (!info) return '';
    var c = info.cents != null ? info.cents * (priceCents / info.base) : priceCents / info.per;
    var ref = String(info.ref || '').trim();
    return money(c, cur) + '/' + (/^1?\s*(kg|l)$/i.test(ref) ? ref.replace(/^1\s*/, '') : ref);
  }

  /* ---------- Bildgrößen angleichen ----------
     Erkennt das Produkt im Foto (Hintergrund an den Ecken) und skaliert es so,
     dass jedes Produkt dieselbe Fläche im Rahmen einnimmt – kleine größer, große kleiner. */
  var fitCv = null;
  function analyze(img) {
    if (img.__fit !== undefined) return img.__fit;
    var nw = img.naturalWidth, nh = img.naturalHeight;
    if (!nw || !nh) return null;
    var S = 72, w = nw >= nh ? S : Math.max(8, Math.round(S * nw / nh)), h = nh > nw ? S : Math.max(8, Math.round(S * nh / nw));
    fitCv = fitCv || D.createElement('canvas');
    fitCv.width = w; fitCv.height = h;
    var cx = fitCv.getContext('2d', { willReadFrequently: true }), d;
    try { cx.clearRect(0, 0, w, h); cx.drawImage(img, 0, 0, w, h); d = cx.getImageData(0, 0, w, h).data; }
    catch (e) { return (img.__fit = null); }
    function px(x, y) { var i = (y * w + x) * 4; return [d[i], d[i + 1], d[i + 2], d[i + 3]]; }
    var cs = [px(0, 0), px(w - 1, 0), px(0, h - 1), px(w - 1, h - 1), px(Math.floor(w / 2), 0), px(Math.floor(w / 2), h - 1)];
    var transp = cs.every(function (c) { return c[3] < 30; }), bg = [0, 0, 0];
    if (!transp) {
      cs.forEach(function (c) { bg[0] += c[0] / cs.length; bg[1] += c[1] / cs.length; bg[2] += c[2] / cs.length; });
      var spread = 0;
      cs.forEach(function (c) { spread = Math.max(spread, Math.abs(c[0] - bg[0]) + Math.abs(c[1] - bg[1]) + Math.abs(c[2] - bg[2])); });
      if (spread > 70) return (img.__fit = { photo: 1 });
    }
    var minx = w, miny = h, maxx = -1, maxy = -1;
    for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
      var i = (y * w + x) * 4, on;
      if (transp) on = d[i + 3] > 40;
      else on = d[i + 3] > 40 && (Math.abs(d[i] - bg[0]) + Math.abs(d[i + 1] - bg[1]) + Math.abs(d[i + 2] - bg[2])) > 46;
      if (on) { if (x < minx) minx = x; if (x > maxx) maxx = x; if (y < miny) miny = y; if (y > maxy) maxy = y; }
    }
    if (maxx < 0) return (img.__fit = null);
    var b = { x: minx / w, y: miny / h, w: (maxx - minx + 1) / w, h: (maxy - miny + 1) / h };
    if (b.w > 0.97 && b.h > 0.97) b.full = 1;
    return (img.__fit = b);
  }
  function fitImg(img, F) {
    var box = img.closest('[data-fit]'); if (!box) return;
    F = F || parseFloat(box.getAttribute('data-fit')) || 0.8;
    var b = analyze(img);
    img.classList.add('is-fit');
    if (!b || b.photo || b.full) { img.style.transform = ''; return; }
    var FW = img.clientWidth, FH = img.clientHeight; if (!FW || !FH) return;
    var ar = img.naturalWidth / img.naturalHeight, rw, rh;
    if (FW / FH > ar) { rh = FH; rw = FH * ar; } else { rw = FW; rh = FW / ar; }
    var s = Math.min(F * FW / (rw * b.w), F * FH / (rh * b.h));
    s = Math.max(0.5, Math.min(2.2, s));
    var dx = (b.x + b.w / 2 - 0.5) * rw, dy = (b.y + b.h / 2 - 0.5) * rh;
    img.style.transform = 'translate(' + (-s * dx / FW * 100).toFixed(2) + '%,' + (-s * dy / FH * 100).toFixed(2) + '%) scale(' + s.toFixed(3) + ')';
  }
  H.classList.add('ap-fitjs');
  function fitAll(scope) {
    $$('[data-fit] img', scope).forEach(function (img) {
      if (img.__fitBound) return; img.__fitBound = 1;
      var run = function () { try { fitImg(img); } catch (e) { img.classList.add('is-fit'); } };
      if (img.complete && img.naturalWidth) run();
      else { img.addEventListener('load', run, { once: true }); img.addEventListener('error', function () { img.classList.add('is-fit'); }, { once: true }); }
    });
  }
  W.arfFit = fitAll;

  /* Liefertermin: Werktage (Mo–Fr) ab heute */
  function addWorkdays(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; }
  function fmtDay(d) {
    try { return new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit' }).format(d).replace(/\.,?\s*/, '., ').replace(/\.$/, '.'); }
    catch (e) { return d.getDate() + '.' + (d.getMonth() + 1) + '.'; }
  }

  /* Warenkorb-Zähler im Header aktualisieren */
  function setCartCount(n) {
    $$('.pets-desktop-cart-count,.pets-mobile-cart-count,[data-cart-count],.cart-count-bubble span:first-child').forEach(function (el) {
      el.textContent = n; el.classList.toggle('is-empty', n < 1);
    });
  }
  var cartCache = null;
  function getCart(force) {
    if (cartCache && !force) return cartCache;
    cartCache = fetch((W.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin', headers: { accept: 'application/json' } })
      .then(function (r) { return r.json(); }).catch(function () { cartCache = null; return null; });
    return cartCache;
  }
  function addToCart(url, items) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) { var e = new Error(j && (j.description || j.message) || 'Fehler'); e.status = r.status; throw e; }
          return j;
        });
      })
      .then(function (j) {
        D.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        D.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        return getCart(true).then(function (c) { if (c) setCartCount(c.item_count || 0); return { added: j, cart: c }; });
      });
  }

  /* ---------- Sternchen & Grundpreis für Karten ---------- */
  function priceHTML(cents, from) {
    var v = Math.round(+cents || 0), e = Math.floor(v / 100), c = ('0' + (v % 100)).slice(-2);
    return (from ? '<small>ab</small> ' : '') + e.toLocaleString('de-DE') + '<sup>,' + c + '</sup><span class="ap-card__cur">€</span>';
  }
  /* quadratischer Bildausschnitt wie auf den Kategorieseiten */
  function sqImg(u) {
    if (!u) return u;
    try { var x = new URL(u, location.href); x.searchParams.set('width', '420'); x.searchParams.set('height', '420'); x.searchParams.set('crop', 'center'); return x.href; } catch (e) { return u; }
  }
  function fillCardUnits(scope, cur) {
    $$('[data-ap-card]', scope).forEach(function (c) {
      var u = $('[data-ap-unit]', c); if (!u || u.textContent) return;
      var p = +c.getAttribute('data-p') || 0;
      var pe = $('.ap-card__price', c); if (pe && p) pe.innerHTML = priceHTML(p, c.getAttribute('data-pv'));
      var info;
      if (c.getAttribute('data-up')) info = { cents: +c.getAttribute('data-up'), base: p, ref: c.getAttribute('data-ur') };
      else if (c.getAttribute('data-c') === '1') { var vt = c.getAttribute('data-vt') || ''; var a = parseAmount((/^default title$/i.test(vt) ? '' : vt) + ' ' + (c.getAttribute('data-t') || '')); if (a) info = { per: a.q, ref: a.u }; }
      if (info) u.textContent = unitText(info, p, cur);
    });
  }

  function init(root) {
    if (root.__ap) return; root.__ap = 1;
    var data = JSON.parse($('[data-ap-json]').textContent);
    var CUR = data.currency || 'EUR';
    var V = data.variants;
    var tiers = data.tiers;
    var maxQ = data.maxQty || 20;
    var state = { v: null, q: 1, opts: [] };

    /* Header-Höhe für sticky-Abstände */
    var lastTop = -1, topRaf;
    function setTop() {
      var el = D.elementFromPoint(W.innerWidth / 2, 3), h = 0;
      while (el && el !== D.body && el !== H) {
        var pos = getComputedStyle(el).position;
        if ((pos === 'fixed' || pos === 'sticky') && !el.closest('.ap,.ap-sticky,.ap-added')) h = Math.max(h, el.getBoundingClientRect().bottom);
        el = el.parentElement;
      }
      var v = Math.round(Math.max(0, Math.min(h, 160)) + 20);
      if (v !== lastTop) { lastTop = v; H.style.setProperty('--ap-top', v + 'px'); }
    }
    function qTop() { cancelAnimationFrame(topRaf); topRaf = requestAnimationFrame(setTop); }
    setTop(); W.addEventListener('resize', qTop, { passive: true }); W.addEventListener('scroll', qTop, { passive: true });

    /* Elemente */
    var el = {
      price: $('[data-ap-price]', root), was: $('[data-ap-was]', root), unit: $('[data-ap-unitline]', root), sku: $('[data-ap-sku]', root),
      badge: $('[data-ap-badge]', root), qty: $('[data-ap-qty]', root), dec: $('[data-ap-dec]', root), inc: $('[data-ap-inc]', root),
      add: $('[data-ap-add]', root), sum: $('[data-ap-sum]', root), err: $('[data-ap-err]', root),
      stock: $('[data-ap-stock]', root), stockTxt: $('[data-ap-stocktxt]', root), eta: $('[data-ap-eta]', root),
      ship: $('[data-ap-ship]', root), shipTxt: $('[data-ap-shiptxt]', root), shipBar: $('[data-ap-shipbar]', root), shipSub: $('[data-ap-shipsub]', root),
      saveNote: $('[data-ap-savenote]', root), sticky: $('[data-ap-sticky]'), sPrice: $('[data-ap-sprice]'), sUnit: $('[data-ap-sunit]'), sAdd: $('[data-ap-sadd]'),
      added: $('[data-ap-added]')
    };
    var tierBtns = $$('[data-ap-tier]', root);
    var optSets = $$('[data-ap-opt]', root);

    /* ---------- Varianten ---------- */
    var urlId = +(new URLSearchParams(location.search).get('variant') || 0);
    state.v = V.filter(function (v) { return v.id === urlId; })[0] || V.filter(function (v) { return v.a; })[0] || V[0];
    state.opts = state.v.o.slice();

    function findVariant(opts) { return V.filter(function (v) { return v.o.every(function (x, i) { return x === opts[i]; }); })[0]; }
    function discount(q) { if (!tiers) return 0; return q >= 3 ? tiers[2] : q === 2 ? tiers[1] : 0; }
    function uinfo(v) { var i = unitInfo(v, data.fullTitle, data.cons); if (i && i.cents != null) i.base = v.p; return i; }

    function renderPills() {
      optSets.forEach(function (fs) {
        var oi = +fs.getAttribute('data-ap-opt');
        var lab = $('[data-ap-optval]', fs); if (lab) lab.textContent = state.opts[oi];
        $$('[data-ap-val]', fs).forEach(function (b) {
          var val = b.getAttribute('data-ap-val');
          b.setAttribute('aria-pressed', String(val === state.opts[oi]));
          var test = state.opts.slice(); test[oi] = val;
          var tv = findVariant(test);
          if (!tv) { var any = V.filter(function (v) { return v.o[oi] === val && v.a; })[0]; b.classList.toggle('is-na', !any); }
          else b.classList.toggle('is-na', !tv.a);
          var sub = $('[data-ap-pillsub]', b);
          if (sub) {
            var sv = tv || V.filter(function (v) { return v.o[oi] === val; })[0];
            var ui = sv && uinfo(sv);
            sub.textContent = sv ? (ui ? unitText(ui, sv.p, CUR) : money(sv.p, CUR)) : '';
          }
        });
      });
    }

    optSets.forEach(function (fs) {
      var oi = +fs.getAttribute('data-ap-opt');
      fs.addEventListener('click', function (e) {
        var b = e.target.closest('[data-ap-val]'); if (!b) return;
        var val = b.getAttribute('data-ap-val');
        var next = state.opts.slice(); next[oi] = val;
        var v = findVariant(next);
        if (!v || !v.a) {
          /* nächste verfügbare Kombination mit diesem Wert */
          var alt = V.filter(function (x) { return x.o[oi] === val && x.a; })[0];
          if (alt) { v = alt; next = alt.o.slice(); }
        }
        if (!v) return;
        state.opts = next; state.v = v;
        if (v.m) goToMedia(v.m);
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (er) {}
        update();
      });
    });

    /* ---------- Menge & Spar-Stufen ---------- */
    function setQty(n) {
      n = Math.max(1, Math.min(maxQ, Math.round(+n || 1)));
      if (state.v && state.v.q != null && state.v.q > 0) n = Math.min(n, state.v.q);
      state.q = n; update();
    }
    el.dec && el.dec.addEventListener('click', function () { setQty(state.q - 1); });
    el.inc && el.inc.addEventListener('click', function () { setQty(state.q + 1); });
    el.qty && el.qty.addEventListener('change', function () { setQty(el.qty.value); });
    tierBtns.forEach(function (b) {
      b.addEventListener('click', function () { var t = +b.getAttribute('data-ap-tier'); setQty(t === 3 ? Math.max(3, state.q) : t); });
    });
    var tg = $('.ap-save__grid', root);
    tg && tg.addEventListener('keydown', function (e) {
      if (!/Arrow(Left|Right|Up|Down)/.test(e.key)) return;
      e.preventDefault();
      var i = tierBtns.indexOf(D.activeElement); i = (i + (/Right|Down/.test(e.key) ? 1 : -1) + tierBtns.length) % tierBtns.length;
      tierBtns[i].focus(); tierBtns[i].click();
    });

    /* ---------- Darstellung ---------- */
    function update() {
      var v = state.v, q = state.q, d = discount(q);
      try { var xI = document.querySelector('[data-ap-express-id]'), xQ = document.querySelector('[data-ap-express-qty]'); if (xI) xI.value = v.id; if (xQ) xQ.value = q; } catch (xe) {}
      var ui = uinfo(v);
      var line = (v.p - Math.floor(v.p * d / 100 + 1e-9)) * q; /* 2026-11-03: wie die Mengenrabatt-App – Rabatt je Stück abgerundet (vorher 1 Cent Abweichung zum Warenkorb) */
      var each = v.p - Math.floor(v.p * d / 100 + 1e-9);

      el.price.textContent = money(v.p, CUR);
      if (v.c > v.p) { el.was.hidden = false; el.was.textContent = money(v.c, CUR); el.badge.hidden = false; el.badge.textContent = '−' + Math.round((v.c - v.p) / v.c * 100) + ' %'; }
      else { el.was.hidden = true; el.badge.hidden = true; }
      el.unit.textContent = ui ? '(' + unitText(ui, v.p, CUR) + ')' : '';
      if (el.sku) { var c = publicCode(v.sku); el.sku.textContent = c ? 'Art.-Nr. ' + c : ''; }

      if (el.qty) el.qty.value = q;
      if (el.dec) el.dec.disabled = q <= 1;
      if (el.inc) el.inc.disabled = q >= maxQ || (v.q != null && v.q > 0 && q >= v.q);

      tierBtns.forEach(function (b) {
        var t = +b.getAttribute('data-ap-tier'), td = +b.getAttribute('data-d') || 0, n = t;
        if (t === 3 && q >= 3) n = q;
        var on = (t === 1 && q === 1) || (t === 2 && q === 2) || (t === 3 && q >= 3);
        var off = !on && v.q != null && v.q > 0 && t > v.q; /* 2026-11-03: Stufe über Lagerbestand sichtbar deaktivieren (vorher toter Klick) */
b.classList.toggle('is-on', on); b.classList.toggle('is-off', off); b.setAttribute('aria-checked', String(on)); b.setAttribute('aria-disabled', String(off)); b.title = off ? 'Nur ' + v.q + ' Stück auf Lager' : ''; b.tabIndex = on ? 0 : -1;
        var e1 = v.p - Math.floor(v.p * td / 100 + 1e-9);
        $('[data-tp]', b).textContent = off ? 'max. ' + v.q + ' Stück' : money(e1 * n, CUR);
        $('[data-tu]', b).textContent = (t === 1 ? 'Stückpreis ' : 'je ') + money(e1, CUR) + (ui ? ' · ' + unitText(ui, e1, CUR) : '');
      });
      if (el.saveNote && tiers) {
        var full = v.p * q, saved = full - line;
        if (d > 0) el.saveNote.innerHTML = 'Je Stück <b>' + esc(money(each, CUR)) + '</b> · du sparst <b>' + esc(money(saved, CUR)) + '</b>';
        else el.saveNote.textContent = '';
      }
      el.sum.textContent = money(line, CUR);

      /* Bestand & Lieferung */
      var out = !v.a;
      el.stock.classList.toggle('is-out', out);
      el.stockTxt.textContent = out ? 'Derzeit ausverkauft' : 'Auf Lager';
      el.eta.textContent = out ? '' : etaText;
      el.add.disabled = out;
      $('[data-ap-addlabel]', el.add).lastChild.textContent = out ? 'Ausverkauft' : addLabel;

      /* Handy-Leiste */
      if (el.sPrice) { el.sPrice.textContent = money(line, CUR); el.sUnit.textContent = q > 1 ? q + ' × ' + money(each, CUR) + (d ? ' · −' + d + ' %' : '') : (ui ? unitText(ui, v.p, CUR) : 'inkl. MwSt.'); el.sAdd.disabled = out; }

      renderPills();
      renderShip();
    }
    var addLabel = $('[data-ap-addlabel]', el.add).lastChild.textContent;

    function publicCode(sku) {
      var raw = String(sku || '').trim(); if (!raw) return '';
      var m = raw.match(/^(.{2})(.+)-EBI$/i); if (m) return 'A' + m[1] + 'B' + m[2] + '-EI';
      return raw.charAt(0) === 'A' ? raw : 'A' + raw;
    }

    var dmin = +el.stock.getAttribute('data-dmin') || 3, dmax = +el.stock.getAttribute('data-dmax') || 7;
    var now = new Date();
    var etaText = 'Lieferung ' + (dmax <= 10 ? fmtDay(addWorkdays(now, dmin)) + ' – ' + fmtDay(addWorkdays(now, dmax)) : 'in ' + dmin + '–' + dmax + ' Werktagen');

    /* Versandkosten-Fortschritt (Warenkorb + aktuelle Auswahl) */
    var cartState = null;
    var TH = +el.ship.getAttribute('data-th') || 0, KG = +el.ship.getAttribute('data-kg') || 0;
    function shipCalc(total, grams) {
      if (!TH) return null;
      var left = TH - total;
      var over = KG > 0 && grams > KG * 1000;
      return { left: left, pct: Math.max(0, Math.min(100, total / TH * 100)), free: left <= 0 && !over, over: over };
    }
    function renderShip() {
      if (!TH) return;
      var c = cartState, count = c ? (c.item_count || 0) : 0, total = c ? (c.total_price || 0) : 0;
      if (!count) {
        el.ship.classList.remove('has-bar', 'is-free');
        el.shipTxt.textContent = 'Kostenloser Versand ab ' + money(TH, CUR);
        el.shipSub.textContent = 'Sonst 5,95 € Versand' + (KG ? ' · bis ' + KG + ' kg Gesamtgewicht' : '');
        return;
      }
      var s = shipCalc(total, c.total_weight || 0);
      el.ship.classList.add('has-bar');
      el.ship.classList.toggle('is-free', s.free);
      el.shipBar.style.width = s.pct + '%';
      if (s.over) { el.shipTxt.textContent = 'Kostenloser Versand ab ' + money(TH, CUR); el.shipSub.textContent = 'gilt bis ' + KG + ' kg Gesamtgewicht'; }
      else if (s.free) { el.shipTxt.textContent = 'Deine Bestellung wird kostenlos versendet'; el.shipSub.textContent = 'Warenkorb: ' + money(total, CUR); }
      else { el.shipTxt.textContent = 'Noch ' + money(s.left, CUR) + ' bis zum kostenlosen Versand'; el.shipSub.textContent = 'Aktuell 5,95 € Versand · Warenkorb: ' + money(total, CUR); }
    }
    idle(function () { getCart().then(function (c) { if (c) { cartState = c; setCartCount(c.item_count || 0); renderShip(); } }); });

    /* ---------- In den Warenkorb ---------- */
    /* Sofort-Feedback: „Hinzugefügt“ erscheint im selben Moment wie der Klick,
       die Anfrage läuft im Hintergrund – bei Fehler wird zurückgesetzt */
    var busy = false, okTimer;
    function setOk(on) { [el.add, el.sAdd].forEach(function (b) { if (b) b.classList.toggle('is-ok', on); }); }
    function doAdd(btn) {
      if (busy || !state.v.a) return;
      busy = true; el.err.hidden = true;
      var v = state.v, q = state.q, d = discount(q), line = (v.p - Math.floor(v.p * d / 100 + 1e-9)) * q;
      var before = cartState ? (cartState.item_count || 0) : null;
      clearTimeout(okTimer); setOk(true);
      okTimer = setTimeout(function () { setOk(false); }, 1000); /* 2026-10-15: grün genau 1 s */
      if (before !== null) setCartCount(before + q);
      openAdded(v, q, line, true);
      addToCart(data.addUrl, [{ id: v.id, quantity: q }]).then(function (res) {
        cartState = res.cart || cartState;
        fillAddedCart();
        state.q = 1; update();
      }).catch(function (e) {
        setOk(false); closeAdded(true);
        if (before !== null) setCartCount(before);
        el.err.hidden = false;
        el.err.textContent = e.status === 422 ? (e.message || 'Diese Menge ist leider nicht verfügbar.') : 'Das hat leider nicht geklappt. Bitte versuche es erneut.';
      }).then(function () { busy = false; });
    }
    el.add.addEventListener('click', function () { doAdd(el.add); });
    el.sAdd && el.sAdd.addEventListener('click', function () { doAdd(el.sAdd); });
    /* Bild für das Panel vorab laden, damit nichts weiß aufblitzt */
    var pre = {};
    function preImg() { var u = (state.v && state.v.img) || data.image; if (u && !pre[u]) { pre[u] = 1; var i = new Image(); i.decoding = 'async'; i.src = u; } }
    ['pointerenter', 'touchstart', 'focus'].forEach(function (t) { [el.add, el.sAdd].forEach(function (b) { if (b) b.addEventListener(t, preImg, { passive: true }); }); });
    idle(preImg);

    /* Hinzugefügt-Panel */
    var addedTimer;
    function fillAddedCart(pending) {
      var p = el.added; if (!p) return;
      var c = cartState || {};
      var cnt = pending ? (c.item_count || 0) + pending.q : c.item_count;
      $('[data-ap-addedcount]', p).textContent = cnt ? '(' + cnt + ')' : '';
      var box = $('.ap-added__ship', p);
      var s = pending ? (cartState ? shipCalc((c.total_price || 0) + pending.line, (c.total_weight || 0) + (pending.w || 0)) : null) : (c.item_count ? shipCalc(c.total_price || 0, c.total_weight || 0) : null);
      if (s) {
        box.hidden = false; box.classList.toggle('is-free', s.free);
        $('[data-ap-addedship]', p).innerHTML = s.free ? '<b>Kostenloser Versand</b> für deine Bestellung' : s.over ? 'Kostenloser Versand gilt bis ' + KG + ' kg Gesamtgewicht' : 'Noch <b>' + esc(money(s.left, CUR)) + '</b> bis zum kostenlosen Versand';
        $('[data-ap-addedbar]', p).style.width = s.pct + '%';
      } else if (!pending) box.hidden = true;
    }
    function openAdded(v, q, line, pending) {
      var p = el.added; if (!p) return;
      var img = v.img || data.image;
      $('[data-ap-addedimg]', p).innerHTML = img ? '<img src="' + esc(img) + '" alt="">' : '';
      $('[data-ap-addedvar]', p).textContent = (v.t && v.t !== 'Default Title' ? v.t + ' · ' : '') + 'Menge ' + q;
      $('[data-ap-addedsum]', p).textContent = money(line, CUR);
      fillAddedCart(pending ? { q: q, line: line, w: (v.w || 0) * q } : null);
      if (W.matchMedia('(min-width: 990px)').matches) {
        var hb = parseInt(getComputedStyle(H).getPropertyValue('--ap-top')) || 20;
        $$('.shopify-section-group-header-group, header').forEach(function (h) { var r = h.getBoundingClientRect(); if (r.top < 220 && r.bottom > 0 && r.bottom + 12 > hb) hb = r.bottom + 12; });
        p.style.top = Math.min(hb, 240) + 'px';
      } else p.style.top = '';
      p.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { p.classList.add('is-in'); }); });
      clearTimeout(addedTimer); addedTimer = setTimeout(closeAdded, 3000);
    }
    function closeAdded() {
      var p = el.added; if (!p || p.hidden) return;
      p.classList.remove('is-in'); setTimeout(function () { p.hidden = true; }, 300);
    }
    if (el.added) {
      $$('[data-ap-addedx]', el.added).forEach(function (b) { b.addEventListener('click', closeAdded); });
      el.added.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') clearTimeout(addedTimer); });
      el.added.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { clearTimeout(addedTimer); addedTimer = setTimeout(closeAdded, 1200); } });
      D.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAdded(); });
      D.addEventListener('click', function (e) { if (!el.added.hidden && !el.added.contains(e.target) && !e.target.closest('[data-ap-add],[data-ap-sadd],[data-ap-quick]')) closeAdded(); });
    }

    /* Handy-Kaufleiste (2026-10-21): erst sichtbar, wenn der Haupt-Button oben aus dem Bild ist UND die Beschreibung erreicht ist – darüber komplett verschwunden */
if (el.sticky && el.add) {
var stInfo = (root && root.querySelector('.ap-info')) || D.querySelector('.ap .ap-info'), stRaf = 0, stOn = null;
var stCheck = function () {
stRaf = 0;
var hdr = (parseFloat(H.style.getPropertyValue('--ap-top')) || 20) - 20;
var past = el.add.getBoundingClientRect().bottom < hdr;
var reach = !stInfo || stInfo.getBoundingClientRect().top < W.innerHeight * 0.85;
var on = past && reach;
if (on === stOn) return;
stOn = on;
H.classList.toggle('ap-sticky-on', on);
el.sticky.setAttribute('aria-hidden', String(!on)); el.sAdd.tabIndex = on ? 0 : -1;
};
var stQueue = function () { if (!stRaf) stRaf = requestAnimationFrame(stCheck); };
W.addEventListener('scroll', stQueue, { passive: true });
W.addEventListener('resize', stQueue, { passive: true });
stCheck();
}

    /* ---------- Galerie ---------- */
    var track = $('[data-ap-track]', root), slides = $$('[data-ap-slide]', root), thumbs = $$('[data-ap-thumb]', root), count = $('[data-ap-count]', root), gi = 0;
    function setIdx(i) {
      gi = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      var at = thumbs[i], rail = $('[data-ap-thumbs]', root);
      if (at && rail) { var left = at.offsetLeft - (rail.clientWidth - at.offsetWidth) / 2; rail.scrollTo({ left: Math.max(0, left), behavior: 'smooth' }); }
    }
    function go(i, inst) {
      if (!track || !slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: track.clientWidth * i, behavior: inst ? 'auto' : 'smooth' });
      setIdx(i);
    }
    function goToMedia(id) { var i = slides.findIndex(function (s) { return +s.getAttribute('data-media-id') === +id; }); if (i >= 0) go(i); }
    if (track) {
      var raf;
      track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { var i = Math.round(track.scrollLeft / (track.clientWidth || 1)); if (i !== gi) setIdx(i); }); }, { passive: true });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-ap-thumb')); }); });
      var pv = $('[data-ap-prev]', root), nx = $('[data-ap-next]', root);
      pv && pv.addEventListener('click', function () { go(gi - 1); });
      nx && nx.addEventListener('click', function () { go(gi + 1); });
      track.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') { e.preventDefault(); go(gi - 1); } if (e.key === 'ArrowRight') { e.preventDefault(); go(gi + 1); } });
      if (state.v.m) { var si = slides.findIndex(function (s) { return +s.getAttribute('data-media-id') === +state.v.m; }); if (si > 0) requestAnimationFrame(function () { go(si, true); }); }
    }

    /* Lightbox (Galerie und Produktbilder) */
    var lb = $('[data-ap-lb]'), lbImg = lb && $('[data-ap-lbimg]', lb), lbList = [], li = 0;
    function lbShow(i) {
      if (!lbList.length) return;
      li = (i + lbList.length) % lbList.length;
      var im = lbList[li], src = im.currentSrc || im.src;
      lbImg.src = src.replace(/([?&])width=\d+/, '$1width=2000'); lbImg.alt = im.alt || '';
      $('[data-ap-lbc]', lb).textContent = lbList.length > 1 ? (li + 1) + ' / ' + lbList.length : '';
    }
    function lbOpen(list, i) {
      if (!lb || typeof lb.showModal !== 'function') return;
      lbList = list.filter(Boolean); if (!lbList.length) return;
      lbShow(Math.max(0, i)); lb.showModal(); H.style.overflow = 'hidden';
    }
    var galImgs = slides.map(function (s) { return $('img', s); });
    function openGallery() { var cur = galImgs[gi]; var list = galImgs.filter(Boolean); lbOpen(list, list.indexOf(cur)); }
    if (lb) {
      $$('[data-ap-slide]', root).forEach(function (s) { if ($('img', s)) s.addEventListener('click', openGallery); });
      var z = $('[data-ap-zoom]', root); z && z.addEventListener('click', openGallery);
      $('[data-ap-lbx]', lb).addEventListener('click', function () { lb.close(); });
      $('[data-ap-lbp]', lb).addEventListener('click', function () { lbShow(li - 1); });
      $('[data-ap-lbn]', lb).addEventListener('click', function () { lbShow(li + 1); });
      lb.addEventListener('close', function () { H.style.overflow = ''; });
      lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
      lb.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') lbShow(li - 1); if (e.key === 'ArrowRight') lbShow(li + 1); });
      var tx = 0;
      lb.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - tx; if (Math.abs(dx) > 45) lbShow(li + (dx < 0 ? 1 : -1)); }, { passive: true });
    }

    /* ---------- Produkt im Detail: höchstens 3 aussagekräftige Bilder ----------
       Vorrang: Bilder aus der Beschreibung (Maßzeichnung, Anleitung, Montage).
       Danach Detail- & Anwendungsfotos aus der Galerie – keine Freisteller auf Weiß,
       keine Farbvarianten, keine Doppelungen mit dem Hauptbild. */
    (function () {
      var wrap = $('[data-ap-ipics]', root), grid = $('[data-ap-ipics-g]', root), tpl = $('template[data-ap-icand]', root);
      if (!wrap || !grid) return;
      var MAX = 3, picks = [];
      var desc = $('[data-ap-desc]', root);
      if (desc) $$('img', desc).forEach(function (im) {
        if (picks.length >= MAX) return;
        var par = im.closest('p,figure,div,a');
        im.removeAttribute('width'); im.removeAttribute('height'); im.removeAttribute('style'); im.loading = 'lazy';
        picks.push(im);
        if (par && par !== desc && !par.textContent.trim() && !par.querySelector('img,video,iframe')) par.remove();
      });
      function render() {
        if (!picks.length) return;
        grid.innerHTML = '';
        grid.className = 'ap-ipics__g is-' + picks.length;
        picks.forEach(function (im) {
          var b = D.createElement('button'); b.type = 'button'; b.className = 'ap-ipic'; b.setAttribute('data-ap-ipic', ''); b.setAttribute('aria-label', 'Bild vergrößern');
          b.appendChild(im); grid.appendChild(b);
        });
        wrap.hidden = false;
        grid.addEventListener('click', function (e) { var b = e.target.closest('[data-ap-ipic]'); if (!b) return; var all = $$('[data-ap-ipic] img', grid); lbOpen(all, all.indexOf($('img', b))); });
      }
      var cands = tpl ? $$('img', tpl.content) : [];
      if (picks.length >= MAX || !cands.length) { render(); return; }
      function probe(src) { return new Promise(function (res) { var i = new Image(); i.decoding = 'async'; i.onload = function () { res(i); }; i.onerror = function () { res(null); }; i.src = src; }); }
      var cvs = D.createElement('canvas'), S = 24; cvs.width = S; cvs.height = S;
      var cx = cvs.getContext('2d', { willReadFrequently: true });
      function stats(img) {
        if (!img) return null;
        var d; try { cx.clearRect(0, 0, S, S); cx.drawImage(img, 0, 0, S, S); d = cx.getImageData(0, 0, S, S).data; } catch (e) { return null; }
        var white = 0, sig = [];
        for (var k = 0; k < S * S; k++) { if (d[k * 4] > 232 && d[k * 4 + 1] > 232 && d[k * 4 + 2] > 232) white++; }
        for (var y = 0; y < 8; y++) for (var x = 0; x < 8; x++) { var i = (Math.floor((y + .5) * S / 8) * S + Math.floor((x + .5) * S / 8)) * 4; sig.push((d[i] + d[i + 1] + d[i + 2]) / 3); }
        return { white: white / (S * S), sig: sig };
      }
      function dist(a, b) { var t = 0; for (var i = 0; i < a.length; i++) t += Math.abs(a[i] - b[i]); return t / a.length; }
      function go() {
        var hero = $('[data-ap-slide] img', root);
        var heroSrc = hero ? String(hero.currentSrc || hero.src).replace(/([?&])width=\d+/, '$1width=160') : null;
        Promise.all([heroSrc ? probe(heroSrc) : null].concat(cands.map(function (c) { return probe(c.getAttribute('data-probe')); }))).then(function (imgs) {
          var hs = stats(imgs[0]), seen = hs ? [hs.sig] : [], list = [];
          cands.forEach(function (c, k) {
            var st = stats(imgs[k + 1]); if (!st) return;
            if (st.white > 0.52) return; /* Freisteller auf Weiß – steht schon oben in der Galerie */
            if (seen.some(function (sg) { return dist(sg, st.sig) < 16; })) return;
            seen.push(st.sig); list.push({ c: c, v: c.getAttribute('data-v') === '1' });
          });
          list.sort(function (a, b) { return a.v - b.v; });
          list.slice(0, MAX - picks.length).forEach(function (o) {
            var im = D.createElement('img'); im.src = o.c.getAttribute('data-src'); im.srcset = o.c.getAttribute('data-srcset'); im.sizes = '(min-width: 990px) 280px, 46vw'; im.alt = o.c.getAttribute('alt') || ''; im.loading = 'lazy';
            picks.push(im);
          });
          render();
        }).catch(render);
      }
      if ('IntersectionObserver' in W) { var io2 = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io2.disconnect(); go(); } }, { rootMargin: '700px 0px' }); io2.observe(wrap.parentElement || wrap); }
      else go();
    })();

    /* ---------- Bewertungen ---------- */
    $$('[data-ap-goto-reviews]', root).forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); var t = $('#bewertungen'); if (t) W.scrollTo({ top: t.getBoundingClientRect().top + W.scrollY - (parseInt(getComputedStyle(H).getPropertyValue('--ap-top')) || 96), behavior: 'smooth' }); });
    });
    var write = $('[data-ap-write]', root), rvMain = $('[data-ap-rvmain]', root);
    if (write) write.addEventListener('click', function () {
      var b = rvMain && ($('.jm-review-widget-minimal-header__action-buttons button', rvMain) || $('.jm-no-reviews-state__action-buttons button', rvMain) || $('.jm-action-buttons__button', rvMain) || $('.jdgm-write-rev-link', rvMain));
      if (b) b.click();
      else if (rvMain) rvMain.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    /* Judge.me-Histogramm übernehmen, falls vorhanden */
    function pullHist() {
      var rows = $$('.jdgm-histogram__row[data-rating], [class*="histogram"] [data-rating]', rvMain);
      var box = $('[data-ap-hist]', root); if (!rows.length || !box) return false;
      var html = '';
      rows.forEach(function (r) {
        var st = r.getAttribute('data-rating'), pc = parseFloat(r.getAttribute('data-percentage') || '0') || 0, fr = r.getAttribute('data-frequency') || '';
        html += '<div class="ap-rv__bar"><span>' + esc(st) + ' ★</span><i style="--w:' + pc + '%"></i><span>' + esc(fr) + '</span></div>';
      });
      box.innerHTML = html; box.hidden = false; return true;
    }
    if (rvMain && 'MutationObserver' in W) {
      var mo = new MutationObserver(function () { if (pullHist()) mo.disconnect(); });
      mo.observe(rvMain, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 15000);
    }
    if (rvMain && !rvMain.children.length) { rvMain.remove(); rvMain = null; root.querySelector('.ap-rv').classList.add('ap-rv--solo'); }

    /* ---------- Empfehlungs-Leisten ---------- */
    function railNav(rail) {
      var t = $('[data-ap-railtrack]', rail), l = $('[data-ap-rl]', rail), r = $('[data-ap-rr]', rail);
      function st() { if (!l) return; l.disabled = t.scrollLeft < 4; r.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 4; }
      l && l.addEventListener('click', function () { t.scrollBy({ left: -t.clientWidth * .9, behavior: 'smooth' }); });
      r && r.addEventListener('click', function () { t.scrollBy({ left: t.clientWidth * .9, behavior: 'smooth' }); });
      t.addEventListener('scroll', st, { passive: true }); st();
    }
    function showRail(rail, nodes) {
      var t = $('[data-ap-railtrack]', rail), seen = {};
      seen[data.handle] = 1;
      nodes.forEach(function (n) { var h = n.getAttribute('data-handle'); if (!h || seen[h]) return; seen[h] = 1; t.appendChild(n); });
      if (t.children.length < 2) return;
      fillCardUnits(t, CUR); rail.hidden = false; railNav(rail); fitAll(t);
    }
    var recoRail = $('[data-ap-rail="reco"]', root), recentRail = $('[data-ap-rail="recent"]', root);
    function fromHTML(html) { var d = D.createElement('div'); d.innerHTML = html; return $$('[data-ap-card]', d); }
    function loadReco() {
      if (!recoRail) return;
      var fb = function () { var tpl = $('template[data-ap-fallback]', recoRail); showRail(recoRail, tpl ? $$('[data-ap-card]', tpl.content).map(function (n) { return n.cloneNode(true); }) : []); };
      fetch(data.recoUrl + '?product_id=' + data.id + '&limit=12&section_id=' + root.getAttribute('data-section'))
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (h) { var n = fromHTML(h); if (n.length >= 3) showRail(recoRail, n); else fb(); })
        .catch(fb);
    }
    if (recoRail && 'IntersectionObserver' in W) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); loadReco(); } }, { rootMargin: '800px 0px' });
      io.observe($('#bewertungen', root) || recoRail);
    } else loadReco();

    /* Zuletzt angesehen (gleicher Speicher wie bisher) */
    var KEY = 'arflonia_recent_products_v3';
    var list = []; try { list = JSON.parse(localStorage.getItem(KEY) || '[]') || []; } catch (e) {}
    if (recentRail) {
      var nodes = list.filter(function (it) { return it && it.handle && it.available !== false && it.handle !== data.handle; }).slice(0, 18).map(function (it) {
        var a = D.createElement('article'); a.className = 'akc'; a.setAttribute('data-akc', ''); a.setAttribute('data-ap-card', ''); a.setAttribute('data-handle', it.handle);
        a.setAttribute('data-p', it.price || 0); a.setAttribute('data-t', it.title || ''); a.setAttribute('data-vt', it.vt || ''); if (it.cons) a.setAttribute('data-c', '1');
        var cents = Math.round(+it.price || 0), pr = Math.floor(cents / 100).toLocaleString('de-DE') + ',' + ('0' + (cents % 100)).slice(-2) + ' €';
        a.innerHTML = '<a class="akc__img" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + (it.image ? '<img src="' + esc(it.image) + '" alt="" loading="lazy" width="400" height="400">' : '') + '</a>' +
          '<a class="akc__t" href="' + esc(it.url) + '">' + (it.vendor ? '<strong>' + esc(it.vendor) + '</strong> ' : '') + esc(String(it.title || '').split(' | ')[0]) + '</a>' +
                    '<span class="akc__p">' + (it.has_multiple ? '<small>ab</small>' : '') + '<span class="arf-pr"><span class="arf-pr__i">' + Math.floor(cents / 100).toLocaleString('de-DE') + '</span><span class="arf-pr__c">,' + ('0' + (cents % 100)).slice(-2) + '</span><span class="arf-pr__e">€</span></span></span>' +
          '<span class="akc__u" data-ap-unit>' + (it.unit ? '(' + esc(it.unit) + ')' : '') + '</span>' +
'<ul class="arf-rinfo"><li><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg><span><b>Gratis<i class="arf-rinfo__x"> Versand</i></b> ab 49 €</span></li><li><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg><span><i class="arf-rinfo__x">Lieferzeit </i><b>3–5 Werktage</b></span></li></ul>' +
          (it.single && it.variant_id ? '<button type="button" class="akc__btn" data-akc-add="' + it.variant_id + '">In den Warenkorb</button>' : (it.single === undefined && !it.has_multiple) ? '<button type="button" class="akc__btn" data-akc-h="' + esc(it.handle) + '">In den Warenkorb</button>' : '<a class="akc__btn" href="' + esc(it.url) + '">Optionen ansehen</a>');
        return a;
      });
      showRail(recentRail, nodes);
    }
    try {
      var cheapest = V.filter(function (v) { return v.a; }).sort(function (a, b) { return a.p - b.p; })[0] || V[0];
      var cu = uinfo(cheapest);
      var item = { handle: data.handle, title: data.fullTitle, url: data.url, image: data.image, price: cheapest.p, variant_id: cheapest.id, available: V.some(function (v) { return v.a; }), has_multiple: V.length > 1 && V.some(function (v) { return v.p !== cheapest.p; }), single: V.length === 1, vendor: data.vendor, vt: cheapest.t, cons: !!data.cons, unit: cu ? unitText(cu, cheapest.p, CUR) : '' };
      localStorage.setItem(KEY, JSON.stringify([item].concat(list.filter(function (x) { return x && x.handle !== data.handle; })).slice(0, 50)));
    } catch (e) {}

    /* Karten-Schnellkauf (gemeinsame Karte) → Versand-Fortschritt hier aktualisieren */
    D.addEventListener('arf:cart:added', function () { getCart(true).then(function (c) { if (c) { cartState = c; setCartCount(c.item_count || 0); renderShip(); } }); });

    /* Produktvideos: nur abspielen, wenn sichtbar */
    var vids = $$('.ap-video__v', root);
    if (vids.length && 'IntersectionObserver' in W) {
      var vo = new IntersectionObserver(function (en) { en.forEach(function (x) { var v = x.target; if (x.isIntersecting && x.intersectionRatio > .5) { v.muted = true; var p = v.play(); p && p.catch(function () {}); } else v.pause(); }); }, { threshold: [0, .5, .8] });
      vids.forEach(function (v) { vo.observe(v); });
    }

    update();
    fitAll(root);
    var rz; W.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { $$('[data-fit] img.is-fit', root).forEach(function (im) { fitImg(im); }); }, 200); }, { passive: true });
  }

  function boot() { $$('[data-ap]').forEach(init); }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
  D.addEventListener('shopify:section:load', boot);
})();

  /* ---------- Zusammensetzung, Analyse, Zusatzstoffe & Fütterungsempfehlung als Tabellen ---------- */
  (function () {
    var KNOWN = /^(zusammensetzung|zutaten|rohstoffe|analytische bestandteile|analytische inhaltsstoffe|analyse|inhaltsstoffe|nährwert\w*|naehrwert\w*|[a-zäöüß]* ?zusatzstoffe|f(ü|ue)tterungs(empfehlung|hinweis\w*)|futtermenge\w*|tagesration|umsetzbare energie|energie\w*|spurenelemente\w*|vitamine\w*|aminosäuren\w*|fettsäuren\w*|mineralstoffe\w*)/i;
    var NUMS = /^(analytische|analyse|inhaltsstoffe|nährwert|naehrwert|ernährungsphysiologische|technologische|sensorische|zootechnische|zusatzstoffe|umsetzbare|energie|spurenelemente|vitamine|aminosäuren|fettsäuren|mineralstoffe)/i;
    var FEED = /f(ü|ue)tterung|futtermenge|tagesration/i;
    var ANALYT = /^(roh)?(protein|proteine|eiweiß|fett|fettgehalt|faser|rohfaser|asche|rohasche|feuchtigkeit|wasser|calcium|kalzium|phosphor|natrium|kalium|magnesium|omega|energie|umsetzbare|kohlenhydrate|zucker|salz|stärke|taurin|nfe)/i;
    var NUMLINE = /^(ca\.?\s*|ab\s+|bis\s+|über\s+|unter\s+|mehr als\s+|weniger als\s+|[<>≤≥]\s*)?\d/i;
    var UNITISH = /(kg|\dg\b|\sg\b|ml|stück|dose|beutel|becher|portion|tasse|schale|%|\d\s*[-–]\s*\d)/i;
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function toText(html) { var d = document.createElement('div'); d.innerHTML = String(html).replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>\s*<p[^>]*>/gi, '\n'); return d.textContent || ''; }
    function lines(s) { return s.split('\n').map(function (x) { return x.replace(/\s+/g, ' ').replace(/\s*;$/, '').trim(); }).filter(Boolean); }
    function clean(l) { return String(l).replace(/\s*:\s*$/, '').trim(); }
    function joinLines(ls) {
      var out = '';
      ls.forEach(function (l) {
        if (!out) { out = l; return; }
        if (/[,;]$/.test(out)) out += ' ' + l;
        else if (/[\d%.)]$|\b(g|mg|µg|mcg|kg|IE|I\.E|kJ|kcal|ml)$/i.test(out) && /^[A-ZÄÖÜ]/.test(l)) out += ', ' + l;
        else out += ' ' + l;
      });
      return out;
    }
    function splitTop(s) {
      var out = [], cur = '', dep = 0;
      for (var i = 0; i < s.length; i++) {
        var c = s.charAt(i), nx = s.slice(i + 1, i + 4);
        if (c === '(' || c === '[') dep++; else if ((c === ')' || c === ']') && dep) dep--;
        var cut = !dep && (((c === ',' || c === ';') && /^\s+[A-Za-zÄÖÜäöüß]/.test(nx)) ||
          (c === '.' && /^\s+[A-ZÄÖÜ]/.test(nx) && /(\d|%|\b(g|mg|µg|mcg|kg|IE|kJ|kcal|ml))$/i.test(cur)));
        if (cut) { if (cur.trim()) out.push(cur.trim()); cur = ''; continue; }
        cur += c;
      }
      if (cur.trim()) out.push(cur.trim());
      return out;
    }
    function item(s) {
      var t = s.replace(/[\s.,;]+$/, '').trim(), k = -1, dep = 0, m;
      for (var i = 0; i < t.length; i++) { var c = t.charAt(i); if (c === '(') dep++; else if (c === ')' && dep) dep--; else if (c === ':' && !dep) k = i; }
      if (k > 0 && /^\s*([<>≤≥]|ca\.?|max\.?|min\.?)?\s*\d/i.test(t.slice(k + 1))) return [t.slice(0, k).trim(), t.slice(k + 1).trim()];
      m = t.match(/^([^()]*[A-Za-zÄÖÜäöüß][^()]*?)\s*\(([^()]*\d[^()]*(?:%|mg|µg|mcg|IE|I\.E|kg|g)[^()]*)\)$/i);
      if (m) return [m[1].trim(), m[2].trim()];
      m = t.match(/^(.*?[A-Za-zÄÖÜäöüß0-9)\]])\s+((?:ca\.?|max\.?|min\.?|mind\.?|[<>≤≥])?\s*\d[\d.,]*.*)$/i);
      if (m && /[A-Za-zÄÖÜäöüß]/.test(m[1]) && m[1].length <= 70 && m[2].length <= 90) return [m[1].trim(), m[2].trim()];
      return null;
    }
    function numTable(body) {
      var ls = lines(body), cap = [], rest = [];
      ls.forEach(function (l) { if (/:\s*$/.test(l) && !/\d/.test(l)) cap.push(clean(l)); else rest.push(l); });
      var parts = splitTop(joinLines(rest)), rows = [], notes = [], ok = 0, its = [];
      parts.forEach(function (p) { var it = item(p); its.push(it); if (it) { ok++; rows.push(it); } else if (p.length > 45) notes.push(p); else rows.push([p.replace(/[\s.,;]+$/, ''), '']); });
      if (rows.length >= 2 && ok >= Math.ceil(rows.length * 0.7)) return { cap: cap.join(' · '), rows: rows, notes: notes };
      /* Zutatenliste + Analysewerte gemischt: Analyse-Teil am Ende abtrennen */
      for (var k = 1; k < parts.length - 2; k++) {
        var tail = its.slice(k);
        if (tail.every(Boolean) && tail.filter(function (r) { return ANALYT.test(r[0]); }).length >= 2)
          return { split: true, text: parts.slice(0, k).join(', '), rows: tail, notes: [] };
      }
      return null;
    }
    var TOK = /^(ca\.?)?[<>≤≥]?\d[\d.,]*(\s*[-–]\s*\d[\d.,]*)?\s*(kg|g|ml|stk\.?|stück|%)?$/i;
    function hdrSplit(h, n) {
      var c = h.split(/\s+[\/|;]\s*|\s*;\s+|\t/).map(clean).filter(Boolean);
      if (c.length === n) return c;
      c = h.match(/^(.*?\))\s+(.*\)?)$/); if (c && n === 2) return [c[1], c[2]];
      c = h.match(/^(.*?)\s+((?:futtermenge|tagesmenge|tagesbedarf|menge|gramm|g pro|g\/|anzahl|stück|portion|pouch|dose|beutel|schale|becher|nassfutter|trockenfutter)\b.*)$/i); if (c && n === 2) return [c[1], c[2]];
      return null;
    }
    function feedTable(body) {
      var raw = lines(body).map(function (l) { return l.replace(/[,;]+$/, '').trim(); }), ls = [];
      raw.forEach(function (l) { if (/^\(/.test(l) && ls.length && !NUMLINE.test(ls[ls.length - 1])) ls[ls.length - 1] += ' ' + l; else ls.push(l); });
      var isData = function (l) { return l.length <= 60 && NUMLINE.test(l); };
      /* längste zusammenhängende Datenreihe finden */
      var bs = -1, be = -1, i, j;
      for (i = 0; i < ls.length; i++) { if (!isData(ls[i])) continue; j = i; while (j < ls.length && isData(ls[j])) j++; if (j - i > be - bs) { bs = i; be = j; } i = j; }
      var res = null;
      if (bs >= 0) {
        var H = ls.slice(Math.max(0, bs - 4), bs).filter(function (h) { return h.length <= 70 && !/[.!]$/.test(h); });
        var R = ls.slice(bs, be), notes = ls.slice(be), pre = ls.slice(0, bs).filter(function (x) { return H.indexOf(x) < 0; });
        var sep = /\s+[\/|]\s+|\s*;\s+|\t/, rows = null, n;
        var split1 = function (r) {
          if (sep.test(r)) return r.split(sep).map(clean);
          var m = r.match(/^((?:ca\.?\s*|bis\s+|ab\s+|über\s+|unter\s+|[<>≤≥]\s*)?[\d.,]+\s*(?:[-–]\s*[\d.,]+\s*)?kg)\s*[:=≡–\-\/]?\s+(.*\d.*)$/i); if (m) return [m[1], m[2]];
          m = r.match(/^(.*?\d.*?)\s*[:=≡]\s+(.*\d.*)$/); if (m) return [m[1], m[2]];
          var t = r.replace(/(\d)\s+(kg|g|ml)\b/gi, '$1$2').split(/\s+/); return t.length >= 2 && t.every(function (z) { return TOK.test(z); }) ? t : [r];
        };
        var sr = R.map(split1); n = sr[0].length;
        if (n >= 2 && sr.every(function (r) { return r.length === n; })) rows = sr;
        else if (sr.length >= 3 && sr[1].length >= 3 && sr[0].length === sr[1].length - 1 && sr.slice(1).every(function (r) { return r.length === sr[1].length; })) {
          /* Raster: erste Zeile = Spaltenköpfe (z. B. Endgewicht 1 kg · 2 kg …) */
          var hl = H.length ? H[H.length - 1] : '', h0 = hl.replace(/(\s+\S+)(\1)+\s*$/, '').replace(/\s+\S+$/, function (w) { return hl.indexOf(w + w) >= 0 ? '' : w; }).trim();
          var grp = (hl.match(/(\S+)(?:\s+\1)+\s*$/) || [])[1] || '';
          res = { head: [h0 || ''].concat(sr[0].map(function (c) { return (grp ? grp + ' ' : '') + c; })), rows: sr.slice(1), notes: pre.concat(H.slice(0, -1), notes) };
        }
        else if (H.length >= 2 && R.length >= H.length * 2 && R.every(function (r) { return TOK.test(r) || r.length <= 22; })) {
          n = H.length; var use = R.length - (R.length % n); rows = [];
          for (var x = 0; x < use; x += n) rows.push(R.slice(x, x + n)); notes = R.slice(use).concat(notes);
          res = { head: H, rows: rows, notes: pre.concat(notes) };
        }
        if (!res && rows && rows.length && n >= 2) {
          var head = H.length === n ? H : (H.length === 1 ? hdrSplit(H[0], n) : null);
          if (!head) { head = ['Körpergewicht', 'Menge pro Tag']; while (head.length < n) head.push(''); if (H.length) pre = H.concat(pre); }
          res = { head: head, rows: rows, notes: pre.concat(notes) };
        }
        if (res && res.rows.length >= 1 && (res.rows.length >= 2 || res.head.join('').length)) return res;
      }
      var J = ls.join(' ');
      /* Zeilen mit „;“ und Spalten mit „ / “ */
      if ((J.match(/;/g) || []).length >= 2) {
        var ch = J.split(/\s*;\s*/).map(function (c) { return c.split(/\s+\/\s*|\s*\/\s+/).map(clean).filter(Boolean); }).filter(function (c) { return c.length; });
        var nn = ch.length > 1 ? ch[1].length : 0, body3 = ch.slice(1).filter(function (c) { return c.length === nn; });
        if (nn >= 2 && body3.length >= 2 && body3.length >= ch.length - 2) return { head: ch[0].length === nn ? ch[0] : ['Körpergewicht'].concat(ch[0].slice(-(nn - 1))), rows: body3, notes: [] };
      }
      /* „3 kg = 30 g 4 kg = 35 g …“ in einer Zeile */
      var RE = /((?:ca\.?\s*|bis\s+|ab\s+|über\s+|unter\s+)?\d[\d.,]*\s*(?:[-–]\s*\d[\d.,]*\s*)?kg)(?:\s+[A-Za-zÄÖÜäöüß]+)?\s*[=:≡]\s*((?:ca\.?\s*)?\d[\d.,]*\s*(?:g|ml|stk\.?|stück|dosen?|beutel|pouch(?:es)?|schalen?)?(?:\s*[-–]\s*\d[\d.,]*\s*(?:g|ml|stk\.?|stück|dosen?|beutel|pouch(?:es)?|schalen?)?)?)/gi, mm, pr = [], first = -1, last = 0;
      while ((mm = RE.exec(J))) { if (first < 0) first = mm.index; pr.push([mm[1].trim(), mm[2].trim()]); last = RE.lastIndex; }
      var RE2 = /((?:ca\.?\s*|bis\s+|ab\s+|über\s+|unter\s+)?\d[\d.,]*\s*kg)(?:\s*[-–]\s*|\s+)((?:ca\.?\s*)?\d[\d.,]*\s*(?:[-–]\s*\d[\d.,]*\s*)?(?:g|ml|stk\.?|stück|dosen?|beutel|pouch(?:es)?|schalen?)\b(?:\s*(?:\/\s*tag|pro tag|täglich))?)/gi, pr2 = [], f2 = -1, l2 = 0;
      while ((mm = RE2.exec(J))) { if (f2 < 0) f2 = mm.index; pr2.push([mm[1].trim(), mm[2].trim()]); l2 = RE2.lastIndex; }
      if (pr2.length > pr.length) { pr = pr2; first = f2; last = l2; }
      if (pr.length >= 2) {
        var hd = J.slice(0, first).replace(/[·\s]+$/, '').trim(), hh = hd.split(/\s*[=≡:]\s*/).map(clean).filter(Boolean);
        var tail2 = J.slice(last).replace(/^[\s·.,;]+/, '').trim();
        return { head: hh.length === 2 ? hh : ['Körpergewicht', 'Menge pro Tag'], rows: pr, notes: (hh.length === 2 || !hd ? [] : [hd]).concat(tail2 ? [tail2] : []) };
      }
      /* waagerechte Reihen: „Gewicht der Katze (kg) 0,5-1 1,5-2,5 3-5“ */
      var hz = ls.map(function (l) { var m = l.match(/^(.*?[A-Za-zÄÖÜäöüß)\]])\s+((?:\S+\s*){2,})$/); if (!m) return null; var t = m[2].trim().split(/\s+/); return t.every(function (z) { return TOK.test(z); }) ? [m[1], t] : null; });
      var hv = hz.filter(Boolean);
      if (hv.length >= 2 && hv.every(function (h) { return h[1].length === hv[0][1].length; })) {
        var rows2 = hv[0][1].map(function (_, k) { return hv.map(function (h) { return h[1][k]; }); });
        return { head: hv.map(function (h) { return h[0]; }), rows: rows2, notes: ls.filter(function (l, k) { return !hz[k]; }) };
      }
      return null;
    }
    function notesHtml(n) { return n && n.length ? '<p class="ap-nutri__note">' + esc(n.join(' ')) + '</p>' : ''; }
    function numBox(lab, t, add) {
      return '<section class="ap-nutri__box' + (add ? ' ap-nutri__box--add' : '') + '"><h4 class="ap-nutri__h"><svg aria-hidden="true"><use href="#ap-i-' + (add ? 'check' : 'leaf') + '"/></svg><span>' + esc(lab) + (t.cap ? ' <small>' + esc(t.cap) + '</small>' : '') + '</span></h4><table class="ap-nutri__t"><tbody>' +
        t.rows.map(function (r) { return '<tr><th scope="row">' + esc(r[0]) + '</th><td>' + esc(r[1]) + '</td></tr>'; }).join('') + '</tbody></table>' + notesHtml(t.notes) + '</section>';
    }
    function render(segs) {
      var main = '', boxes = '';
      segs.forEach(function (s, si) {
        var lab = clean(s.label), body = s.body, t, ls = lines(body);
        if (!lab) { if (ls.length) main += '<tr><td colspan="2">' + esc(ls.join(' ')) + '</td></tr>'; return; }
        if (!ls.length && segs[si + 1] && KNOWN.test(clean(segs[si + 1].label))) return; /* Überschrift ohne Inhalt (z. B. „Zusatzstoffe:“ vor Unterpunkten) */
        if (FEED.test(lab) && (t = feedTable(body))) {
          boxes += '<section class="ap-nutri__box ap-nutri__box--feed"><h4 class="ap-nutri__h"><svg aria-hidden="true"><use href="#ap-i-bowl"/></svg><span>' + esc(lab) + '</span></h4><div class="ap-nutri__scroll"><table class="ap-nutri__t ap-nutri__t--feed"><thead><tr>' +
            t.head.map(function (h) { return '<th scope="col">' + esc(h) + '</th>'; }).join('') + '</tr></thead><tbody>' +
            t.rows.map(function (r) { return '<tr>' + r.map(function (c, ci) { return ci ? '<td>' + esc(c) + '</td>' : '<th scope="row">' + esc(c) + '</th>'; }).join('') + '</tr>'; }).join('') + '</tbody></table></div>' + notesHtml(t.notes) + '</section>';
          return;
        }
        if (!FEED.test(lab) && (t = numTable(body)) && (NUMS.test(lab) || t.split)) {
          if (t.split) { main += '<tr><th scope="row">' + esc(lab) + '</th><td>' + esc(t.text) + '</td></tr>'; boxes += numBox('Analytische Bestandteile', t, false); }
          else boxes += numBox(lab, t, /zusatzstoffe/i.test(lab));
          return;
        }
        main += '<tr><th scope="row">' + esc(lab) + '</th><td>' + (ls.length ? esc(FEED.test(lab) ? ls.join(' · ') : joinLines(ls)) : '–') + '</td></tr>';
      });
      return '<div class="ap-nutri">' + (main ? '<div class="ap-spec-w"><table class="ap-spec ap-nutri__main"><tbody>' + main + '</tbody></table></div>' : '') +
        (boxes ? '<div class="ap-nutri__grid">' + boxes + '</div>' : '') + '</div>';
    }
    function parse(html) {
      var bits = String(html).split(/<(?:strong|b)>/i), segs = [], pre = bits.shift();
      if (lines(toText(pre)).length) segs.push({ label: '', body: toText(pre) });
      bits.forEach(function (b) { var k = b.search(/<\/(?:strong|b)>/i); if (k < 0) return; segs.push({ label: toText(b.slice(0, k)), body: toText(b.slice(k).replace(/^<\/(?:strong|b)>/i, '')) }); });
      return segs;
    }
    function firstLabel(p) { var s = p.querySelector('strong,b'); return s && p.textContent.trim().indexOf(s.textContent.trim()) === 0 ? clean(s.textContent) : ''; }
    function run(box) {
      var kids = [].slice.call(box.children), done = 0;
      for (var i = 0; i < kids.length; i++) {
        var p = kids[i]; if (p.tagName !== 'P' || !KNOWN.test(firstLabel(p))) continue;
        var grp = [p], j = i + 1;
        while (j < kids.length && kids[j].tagName === 'P') {
          var n = kids[j], fl = firstLabel(n), tx = n.textContent.trim();
          if (!tx || /^angaben laut/i.test(tx) || (n.children.length === 1 && n.firstElementChild.tagName === 'EM')) break;
          if (fl && !KNOWN.test(fl)) break;
          grp.push(n); j++;
        }
        var segs = parse(grp.map(function (g) { return g.innerHTML; }).join('<br>'));
        if (!segs.some(function (s) { return KNOWN.test(clean(s.label)); })) continue;
        var w = document.createElement('div'); w.innerHTML = render(segs);
        var el = w.firstElementChild; p.parentNode.insertBefore(el, p); grp.forEach(function (g) { g.parentNode.removeChild(g); });
        done++; i = j - 1;
      }
      return done;
    }
    window.arfNutri = run;
    var go = function () { var scope = document.querySelector('.ap-info__main'); if (scope) [].forEach.call(scope.querySelectorAll('.ap-rte'), function (b) { try { run(b); } catch (e) {} }); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  })();
